import { ChangeDetectorRef, Directive, inject, Type } from '@angular/core';
import { KnowledgeSource } from '@vendasta/embeddings';

@Directive()
export abstract class CommonKnowledgeSourceEditorComponent {
  knowledgeSource: KnowledgeSource;
  readOnly: boolean;
  disableSubmit = false;
  cdr = inject(ChangeDetectorRef);

  // init is run after the component is created and data is set
  init(): void {
    return;
  }

  // submit will be called when the submit action in the editor is clicked
  // should return the knowledge source id if it is created or update
  // a falsy return value will not close the dialog or move to the next step
  async submit(): Promise<string> {
    return;
  }

  // if nextStep is provided, the submit action will be changed from Save to Next, and the given component will be rendered
  // Note: the submit function will still be called before rendering the next step
  nextStep(): Type<CommonKnowledgeSourceEditorComponent> {
    return;
  }

  // if previousStep is provided, a Back button will be included in the actions that will render the given component
  previousStep(): Type<CommonKnowledgeSourceEditorComponent> {
    return;
  }

  // getEditOption is used to build a query param that will link to this component's step, if it is not the first step
  getEditOption(): string {
    return;
  }

  // if true, a warning will be shown when cancelling or going to a previous step
  hasUnsavedChanges(): boolean {
    return false;
  }
}
